export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "ATP Tour Sustainability Report 2025",
  "shortTitle": "",
  "description": "",
  "width": 1263,
  "height": 893,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/2025", 
  //  "basePath": "", 
  "companyLogo": "1-logo-1.png",
  "publishURL": "",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "subscribeEnabled": true,
    "downloadEnabled": false,
    "downloadPath": false,
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true,
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true,
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true,
  },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `


      <!-- popup-1 CARBON -->
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click" style="top:377px;left:214px;" onclick="showOverlay('1-pop-1')" src="/2025/static/_content/1-click-1.png"/>
      <div id="1-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 1-pop-1" style="top:0px;left:22px;" src="/2025/static/_content/1-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopOne()"></div>

        <!-- pop-1-clicks CARBON -->

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1" style="top:478px;left:1019px;" onclick="openPop('1-carbontracker', '1-carbontracker-1')" src="/2025/static/_content/1-click-1-green.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1" style="top:786px;left:945px;" onclick="openPop('1-carbontracker', '1-carbontracker-2')" src="/2025/static/_content/1-click-1-green.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1" style="top:786px;left:360px;" onclick="openPop('1-carbontracker', '1-carbontracker-3')" src="/2025/static/_content/1-click-1-green.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click-1" style="top:296px;left:736px;" onclick="openPop('1-carbontracker', '1-carbontracker-4')" src="/2025/static/_content/1-click-1-white.png"/>

        <!-- pop-ups CARBON -->

        <div id="1-carbontracker-1" class="1-carbontracker hidden noclick">
          <img class="abs halfScale 1-pop-1-1" style="top:105px;left:612px;" src="/2025/static/_content/1-pop-1-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:105px;left:1151px;width:41px;height:42px;" onclick="closePop('1-carbontracker')"></div>
        </div>

        <div id="1-carbontracker-2" class="1-carbontracker hidden noclick">
          <img class="abs halfScale 1-pop-1-2" style="top:105px;left:612px;" src="/2025/static/_content/1-pop-1-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:105px;left:1151px;width:41px;height:42px;" onclick="closePop('1-carbontracker')"></div>
        </div>

        <div id="1-carbontracker-3" class="1-carbontracker hidden noclick">
          <img class="abs halfScale 1-pop-1-3" style="top:158px;left:352px;" src="/2025/static/_content/1-pop-1-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:808px;left:473px;width:41px;height:42px;" onclick="closePop('1-carbontracker')"></div>
        </div>

        <div id="1-carbontracker-4" class="1-carbontracker hidden noclick">
          <img class="abs halfScale 1-pop-1-4" style="top:128px;left:385px;" src="/2025/static/_content/1-pop-1-4.png"/>
          <div class="abs contentLinkNone pointer" style="top:128px;left:866px;width:41px;height:42px;" onclick="closePop('1-carbontracker', '1-carbontracker-4')"></div>
        </div>

      </div>


      <!--- popup-2 NITTO --->

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click" style="top:89px;left:603px;" onclick="openOnePopTwo()" src="/2025/static/_content/1-click-2.png"/>
      <div id="1-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 1-pop-2" style="top:0px;left:40px;" src="/2025/static/_content/1-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>

        <!--- animations --->
        <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:263px;left:1094px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;"  data-number='{"to": 70, "append": "%"}' ></h1>
        <img class="abs halfScaleC pop-2-text" style="top:287px;left:1065px;" src="/2025/static/_content/1-pop-2-text-1.png"/>
        <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:408px;left:1088px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;"  data-number='{"to": 673}' ></h1>
        <img class="abs halfScaleC pop-2-text" style="top:417px;left:1035px;" src="/2025/static/_content/1-pop-2-text-2.png"/>
        <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:534px;left:955px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;"  data-number='{"to": 11000, "comma": true}' ></h1>
        <img class="abs halfScaleC pop-2-text" style="top:577px;left:944px;" src="/2025/static/_content/1-pop-2-text-3.png"/>
        <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:521px;left:812px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;"  data-number='{"to": 2500, "comma": true}' ></h1>
        <img class="abs halfScale pop-2-text" style="top:571px;left:810px;" src="/2025/static/_content/1-pop-2-text-4.png"/>
        <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:447px;left:712px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;"  data-number='{"to": 42, "append": "%"}' ></h1>
        <img class="abs halfScaleC pop-2-text" style="top:487px;left:674px;" src="/2025/static/_content/1-pop-2-text-5.png"/>
        <img class="abs halfScaleC pop-2-text" style="top:368px;left:615px;" src="/2025/static/_content/1-pop-2-text-6.png"/>
        <img class="abs halfScaleC pop-2-text-7" style="top:328px;left:662px;" src="/2025/static/_content/1-pop-2-text-7.png"/>
        <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:227px;left:721px; font-size: 2.9em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;"  data-number='{"to": 75, "append": "%"}' ></h1>
        <img class="abs halfScaleC pop-2-text" style="top:260px;left:656px;" src="/2025/static/_content/1-pop-2-text-8.png"/>
        

        <!--- popup clicks NITTO --->

        <img class="abs halfScaleC pointer 2-click" style="top:638px;left:573px;" onclick="openPop('1-nitto-atp', '1-nitto-atp-1')" src="/2025/static/_content/1-box.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 2-click" style="top:738px;left:605px;" onclick="openPop('1-nitto-atp', '1-nitto-atp-1')" src="/2025/static/_content/2-click-1.png"/>
        <img class="abs halfScaleC pointer 2-click" style="top:638px;left:750px;" onclick="openPop('1-nitto-atp', '1-nitto-atp-2')" src="/2025/static/_content/1-box.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 2-click" style="top:738px;left:851px;" onclick="openPop('1-nitto-atp', '1-nitto-atp-2')" src="/2025/static/_content/2-click-2.png"/>
        <img class="abs halfScaleC pointer 2-click" style="top:638px;left:927px;" onclick="openPop('1-nitto-atp', '1-nitto-atp-3')" src="/2025/static/_content/1-box.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 2-click" style="top:738px;left:965px;" onclick="openPop('1-nitto-atp', '1-nitto-atp-3')" src="/2025/static/_content/2-click-3.png"/>
     
        <!--- pop-up environment --->

        <div id="1-nitto-atp-1" class="1-nitto-atp hidden noclick">
          <img class="abs halfScale 1-pop-2-1" style="top:38px;left:39px;" src="/2025/static/_content/1-pop-2-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:60px;left:1157px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>

          <!--- environment clicks --->
      
          <img class="abs halfScaleC pointer click-2" style="top:95px;left:-25px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-4')" src="/2025/static/_content/click-2-1.png"/>
          <img class="abs halfScaleC pointer click-2" style="top:95px;left:244px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-5')" src="/2025/static/_content/click-2-2.png"/>
          <img class="abs halfScaleC pointer click-2" style="top:95px;left:511px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-6')" src="/2025/static/_content/click-2-3.png"/>
          <img class="abs halfScaleC pointer click-2" style="top:95px;left:779px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-7')" src="/2025/static/_content/click-2-4.png"/>
          <img class="abs halfScaleC pointer click-2" style="top:383px;left:-25px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-8')" src="/2025/static/_content/click-2-5.png"/>
          <img class="abs halfScaleC pointer click-2" style="top:383px;left:244px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-9')" src="/2025/static/_content/click-2-6.png"/>
          <img class="abs halfScaleC pointer click-2" style="top:383px;left:511px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-10')" src="/2025/static/_content/click-2-7.png"/>
          <img class="abs halfScaleC pointer click-2" style="top:383px;left:779px;" onclick="openPop('1-nitto-atp-env', '1-nitto-atp-11')" src="/2025/static/_content/click-2-8.png"/>

          <!--- environment boxes popups --->
          
          <div id="1-nitto-atp-4" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-1" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-1.png"/>
            <div class="abs contentLinkNone pointer" style="top:231px;left:582px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

          <div id="1-nitto-atp-5" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-2" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-2.png"/>
            <div class="abs contentLinkNone pointer" style="top:231px;left:850px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

          <div id="1-nitto-atp-6" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-3" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-3.png"/>
            <div class="abs contentLinkNone pointer" style="top:231px;left:1119px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

          <div id="1-nitto-atp-7" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-4" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-4.png"/>
            <div class="abs contentLinkNone pointer" style="top:231px;left:851px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

          <div id="1-nitto-atp-8" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-5" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-5.png"/>
            <div class="abs contentLinkNone pointer" style="top:231px;left:582px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

          <div id="1-nitto-atp-9" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-6" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-6.png"/>
            <div class="abs contentLinkNone pointer" style="top:521px;left:851px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

          <div id="1-nitto-atp-10" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-7" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-7.png"/>
            <div class="abs contentLinkNone pointer" style="top:231px;left:1119px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

          <div id="1-nitto-atp-11" class="1-nitto-atp-env hidden noclick">
            <img class="abs halfScale 1-pop-2-1-8" style="top:37px;left:22px;pointer" src="/2025/static/_content/1-pop-2-1-8.png"/>
            <div class="abs contentLinkNone pointer" style="top:231px;left:849px;width:41px;height:42px;" onclick="closePop('1-nitto-atp-env')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
          </div>

        </div>

        <!--- pop-up social --->

        <div id="1-nitto-atp-2" class="1-nitto-atp hidden noclick">
          <img class="abs halfScale 1-pop-2-2" style="top:38px;left:23px;" src="/2025/static/_content/1-pop-2-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:60px;left:1157px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
        </div>

        <!--- pop-up governance --->

        <div id="1-nitto-atp-3" class="1-nitto-atp hidden noclick">
          <img class="abs halfScale 1-pop-2-3" style="top:38px;left:40px;" src="/2025/static/_content/1-pop-2-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:60px;left:1157px;width:41px;height:42px;" onclick="closePop('1-nitto-atp')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopTwo()"></div>
        </div>

      </div>


      <!--- popup-3 SPORTIMPACT --->

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click" style="top:478px;left:244px;" onclick="showOverlay('1-pop-3')" src="/2025/static/_content/1-click-3.png"/>
      <div id="1-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 1-pop-3" style="top:0px;left:22px;" src="/2025/static/_content/1-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="hideOverlay('1-pop-3')"></div>
      </div>


      <!--- popup-4 CARBONFOOTPRINT --->

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click" style="top:786px;left:504px;" onclick="openOnePopFour()" src="/2025/static/_content/1-click-4.png"/>
      <div id="1-pop-4" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 1-pop-4" style="top:0px;left:22px;" src="/2025/static/_content/1-pop-4.png"/>
        <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFour()"></div>

        <!--- animations --->

        <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:442px;left:640px; font-size: 5.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 3826, "comma": true}' ></h1>
        <img class="abs halfScaleC 4-box" style="top:104px;left:493px;" src="/2025/static/_content/4-box-1.png"/>
        <h1 id="1-no" class="abs rocG-Cond 1-no" style="top:222px;left:618px; font-size: 4.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 126}' ></h1>
        <img class="abs halfScaleC 4-box" style="top:563px;left:644px;" src="/2025/static/_content/4-box-2.png"/>
        <h1 id="1-no" class="abs rocG-Cond 1-no" style="top:678px;left:735px; font-size: 4.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 3700, "comma": true}' ></h1>

      </div>


      <!--- popup-5 FANTRAVEL --->

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 1-click" style="top:516px;left:939px;" onclick="openOnePopFive()" src="/2025/static/_content/1-click-5.png"/>
      <div id="1-pop-5" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 1-pop-5" style="top:0px;left:22px;" src="/2025/static/_content/1-pop-5.png"/>
        <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFive()"></div>

        <!--- popup clicks --->

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 5-click" style="top:382px;left:249px;" onclick="popFiveAnimation('1-fan-travel', '1-fan-travel-1')" src="/2025/static/_content/click-5-1.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 5-click" style="top:756px;left:258px;" onclick="popFiveAnimation('1-fan-travel', '1-fan-travel-2')" src="/2025/static/_content/click-5-2.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 5-click" style="top:287px;left:626px;" onclick="popFiveAnimation('1-fan-travel', '1-fan-travel-3')" src="/2025/static/_content/click-5-3.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 5-click" style="top:519px;left:904px;" onclick="popFiveAnimation('1-fan-travel', '1-fan-travel-4')" src="/2025/static/_content/click-5-3.png"/>
        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 5-click" style="top:741px;left:914px;" onclick="popFiveAnimation('1-fan-travel', '1-fan-travel-5')" src="/2025/static/_content/click-5-3.png"/>

        <!--- popup-5: first --->

        <div id="1-fan-travel-1" class="1-fan-travel  hidden noclick">
          <img class="abs halfScale 1-pop-5-1" style="top:37px;left:39px;" src="/2025/static/_content/1-pop-5-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:775px;left:74px;width:41px;height:42px;" onclick="closePop('1-fan-travel')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFive()"></div>

          <!--- animations --->

          <img class="abs halfScaleC 5-title" style="top:147px;left:-68px;" src="/2025/static/_content/5-title-1.png"/>
          <img class="abs halfScaleC 5-title" style="top:206px;left:-124px;" src="/2025/static/_content/5-subtext-1.png"/>

          <img class="abs halfScaleC 5-heading" style="top:282px;left:94px;" src="/2025/static/_content/5-heading-1.png"/>
          <img class="abs halfScaleC 5-arrow" style="top:321px;left:-15px;" src="/2025/static/_content/5-arrow-1.png"/>
          <img class="abs halfScaleC 5-arrow" style="top:373px;left:-12px;" src="/2025/static/_content/5-arrow-2.png"/>
          <img class="abs halfScaleC 5-arrow" style="top:426px;left:-22px;" src="/2025/static/_content/5-arrow-3.png"/>
          <img class="abs halfScaleC 5-line" style="top:354px;left:358px;" src="/2025/static/_content/5-line-1.png"/>
          <img class="abs halfScaleC 5-circle" style="top:333px;left:344px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:333px;left:423px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:333px;left:505px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:333px;left:588px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:333px;left:678px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:333px;left:762px;" src="/2025/static/_content/5-circle-blue.png"/>
  

          <img class="abs halfScaleC 5-line" style="top:406px;left:358px;" src="/2025/static/_content/5-line-2.png"/>
          <img class="abs halfScaleC 5-circle" style="top:386px;left:344px;" src="/2025/static/_content/5-circle-white.png"/>
          <img class="abs halfScaleC 5-circle" style="top:386px;left:423px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:386px;left:505px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:386px;left:588px;" src="/2025/static/_content/5-circle-white.png"/>
          <img class="abs halfScaleC 5-circle" style="top:386px;left:678px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:386px;left:762px;" src="/2025/static/_content/5-circle-white.png"/>

          <img class="abs halfScaleC 5-line" style="top:462px;left:358px;" src="/2025/static/_content/5-line-3.png"/>
          <img class="abs halfScaleC 5-circle" style="top:441px;left:344px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:441px;left:423px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:441px;left:505px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:441px;left:588px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:441px;left:678px;" src="/2025/static/_content/5-circle-blue.png"/>
          <img class="abs halfScaleC 5-circle" style="top:441px;left:762px;" src="/2025/static/_content/5-circle-white.png"/>

          <img class="abs halfScaleC 5-heading" style="top:535px;left:128px;" src="/2025/static/_content/5-heading-2.png"/>
          <img class="abs halfScaleC 5-arrow-2" style="top:574px;left:-15px;" src="/2025/static/_content/5-arrow-4.png"/>
          <img class="abs halfScaleC 5-arrow-2" style="top:636px;left:-15px;" src="/2025/static/_content/5-arrow-5.png"/>
          <img class="abs halfScaleC 5-arrow-2" style="top:698px;left:-31px;" src="/2025/static/_content/5-arrow-6.png"/>

          <img class="abs halfScaleC 5-outline" style="top:530px;left:300px;" src="/2025/static/_content/5-outline-1.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:587px;left:395px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 883}' ></h1>
          <img class="abs halfScaleC 5-outline" style="top:520px;left:469px;" src="/2025/static/_content/5-outline-2.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:587px;left:546px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 1.1, "decimals": 1, "append": "%"}' ></h1>
          <img class="abs halfScaleC 5-outline" style="top:538px;left:569px;" src="/2025/static/_content/5-outline-3.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:587px;left:694px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 2582, "comma": true}' ></h1>

          <img class="abs halfScaleC 5-outline" style="top:592px;left:300px;" src="/2025/static/_content/5-outline-1.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:647px;left:383px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 1575, "comma": true}' ></h1>
          <img class="abs halfScaleC 5-outline" style="top:579px;left:470px;" src="/2025/static/_content/5-outline-2.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:648px;left:546px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 1.3, "decimals": 1, "append": "%"}' ></h1>
          <img class="abs halfScaleC 5-outline" style="top:598px;left:569px;" src="/2025/static/_content/5-outline-3.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:648px;left:684px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 11953, "comma": true}' ></h1>

          <img class="abs halfScaleC 5-outline" style="top:655px;left:300px;" src="/2025/static/_content/5-outline-1.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:713px;left:395px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 815}' ></h1>
          <img class="abs halfScaleC 5-outline" style="top:645px;left:470px;" src="/2025/static/_content/5-outline-2.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:713px;left:546px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 1.9, "decimals": 1, "append": "%"}' ></h1>
          <img class="abs halfScaleC 5-outline" style="top:656px;left:569px;" src="/2025/static/_content/5-outline-3.png"/>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:714px;left:694px; font-size: 2.8em; font-weight: 300; color: #1bdce0; padding: 0px; margin: 0px;" data-number='{"to": 6151, "comma": true}' ></h1>
          
          <img class="abs halfScaleC bluebox" style="top:-320px;left:718px;" src="/2025/static/_content/blue-box.png"/>

          <img class="abs halfScaleC 5-title-2" style="top:106px;left:842px;" src="/2025/static/_content/5-title-2.png"/>
          <img class="abs halfScaleC 5-subtext" style="top:151px;left:785px;" src="/2025/static/_content/5-subtext-2.png"/>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:182px;left:915px; font-size: 2.7em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;" data-number='{"to": 43}' ></h1>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:182px;left:1001px; font-size: 2.7em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;" data-number='{"to": 174}' ></h1>
          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:182px;left:1112px; font-size: 2.7em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;" data-number='{"to": 15}' ></h1>

          <img class="abs halfScaleC 5-heading-text" style="top:214px;left:775px;" src="/2025/static/_content/5-heading-3.png"/>

          <img class="abs halfScaleC 5-subtext" style="top:276px;left:811px;" src="/2025/static/_content/5-subtext-3.png"/>

          <img class="abs halfScaleC 5-piechart" style="top:304px;left:864px;" src="/2025/static/_content/5-piechart-1.png"/>
          <img class="abs halfScaleC 5-piechart" style="top:304px;left:961px;" src="/2025/static/_content/5-piechart-2.png"/>
          <img class="abs halfScaleC 5-piechart" style="top:304px;left:1056px;" src="/2025/static/_content/5-piechart-3.png"/>
          <img class="abs halfScaleC 5-heading-text" style="top:410px;left:775px;" src="/2025/static/_content/5-heading-3.png"/>

          <img class="abs halfScaleC 5-subtext" style="top:479px;left:768px;" src="/2025/static/_content/5-subtext-4.png"/>

          <img class="abs halfScaleC 5-piechart-2" style="top:511px;left:864px;" src="/2025/static/_content/5-piechart-4.png"/>
          <img class="abs halfScaleC 5-piechart-2" style="top:511px;left:961px;" src="/2025/static/_content/5-piechart-5.png"/>
          <img class="abs halfScaleC 5-piechart-2" style="top:511px;left:1056px;" src="/2025/static/_content/5-piechart-6.png"/>
          <img class="abs halfScaleC 5-heading-text" style="top:617px;left:775px;" src="/2025/static/_content/5-heading-3.png"/>

          <img class="abs halfScaleC 5-quote" style="top:675px;left:776px;" src="/2025/static/_content/5-quote.png"/>         
        </div>

        <!--- popup-5: second --->

        <div id="1-fan-travel-2" class="1-fan-travel  hidden noclick">
          <img class="abs halfScale 1-pop-5-2" style="top:38px;left:22px;" src="/2025/static/_content/1-pop-5-2.png"/>
          <img class="abs halfScaleC animatedpulse halfpulsetwo pointer click-5-2-2" style="top:393px;left:214px;" onclick="openPop('1-fan-travel-phone', '1-fan-travel-6')" src="/2025/static/_content/click-5-2-3.png"/>
          <img class="abs halfScaleC animatedpulse halfpulsetwo pointer click-5-2-2" style="top:347px;left:295px;" onclick="openPop('1-fan-travel-phone', '1-fan-travel-6')" src="/2025/static/_content/click-5-2-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:59px;left:1157px;width:41px;height:42px;" onclick="closePop('1-fan-travel')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFive()"></div>

          <div id="1-fan-travel-6" class="1-fan-travel hidden noclick">
            <img class="abs halfScale 1-pop-5-2-1" style="top:170px;left:648px;" src="/2025/static/_content/1-pop-5-2-1.png"/>
            <div class="abs contentLinkNone pointer" style="top:730px;left:664px;width:41px;height:42px;" onclick="closePop('1-fan-travel-phone')"></div>
            <div class="abs contentLinkNone pointer" style="top:59px;left:1156px;width:41px;height:42px;" onclick="closePop('1-fan-travel');closePop('1-fan-travel-phone')"></div>
            <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFive()"></div>
          </div>
        </div>

        <!--- popup-5: third --->

        <div id="1-fan-travel-3" class="1-fan-travel hidden noclick">
          <img class="abs halfScale 1-pop-5-3-1" style="top:164px;left:642px;" src="/2025/static/_content/1-pop-5-3-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:750px;left:1105px;width:41px;height:42px;" onclick="closePop('1-fan-travel')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFive()"></div>

          <!--- animations --->

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:246px;left:670px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 1575, "comma":true}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:246px;left:876px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 11953, "comma":true}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:421px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 53, "append": "%"}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:655px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 73, "append": "%"}' ></h1>
        </div>

        <div id="1-fan-travel-4" class="1-fan-travel hidden noclick">
          <img class="abs halfScale 1-pop-5-2-3" style="top:164px;left:642px;" src="/2025/static/_content/1-pop-5-3-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:750px;left:1105px;width:41px;height:42px;" onclick="closePop('1-fan-travel')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFive()"></div>

          <!--- animations --->

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:246px;left:670px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 883}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:246px;left:876px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 2582, "comma":true}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:421px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 56, "append": "%"}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:655px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;"  data-number='{"to": 58, "append": "%"}' ></h1>
        </div>

        <div id="1-fan-travel-5" class="1-fan-travel hidden noclick">
          <img class="abs halfScale 1-pop-5-3-3" style="top:164px;left:642px;" src="/2025/static/_content/1-pop-5-3-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:750px;left:1105px;width:41px;height:42px;" onclick="closePop('1-fan-travel')"></div>
          <div class="abs contentLinkNone pointer" style="top:1px;left:1188px;width:41px;height:42px;" onclick="closeOnePopFive()"></div>
          
          <!--- animations --->

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:259px;left:670px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;" data-number='{"to": 815}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:259px;left:876px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;" data-number='{"to": 6151, "comma":true}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:433px;left:736px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;" data-number='{"to": 74, "append": "%"}' ></h1>

          <h1 id="1-no" class="abs rocG-CondBd 1-no" style="top:667px;left:737px; font-size: 2.8em; font-weight: 300; color: #ffffffff; padding: 0px; margin: 0px;" data-number='{"to": 80, "append": "%"}' ></h1>
        </div>
      </div>


      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
        }

        function openPop(klass, id) {
          popups = cOf(klass);
          ele = idOf(id);
          for(var i=0; i<popups.length; i++) {
            popups[i].className = klass + " hidden noclick";
          }
          if(klass == "1-fan-travel") {
            childs = cOf('1-fan-travel-phone')
            for(var i=0; i<childs.length; i++) {
              childs[i].className = '1-fan-travel-phone hidden click'
            }
          }
          ele.className = klass + " visible"
        }

        function closePop(klass) {
          popups = cOf(klass);
          for(var i=0; i<popups.length; i++) {
            popups[i].className = klass + " hidden noclick";
          }
          if(klass == "1-nitto-atp") {
            childs = cOf('1-nitto-atp-env')
            for(var i=0; i<childs.length; i++) {
              childs[i].className = '1-nitto-atp-env hidden noclick'
            }
          }
          if(klass == "1-fan-travel") {
            pg1Anim.stop()
            resetNumbers("1-no")
          }
        }

        function closeOnePopOne() {
          hideOverlay('1-pop-1')
          closePop('1-carbontracker')
        }

        function openOnePopTwo() {
          showOverlay('1-pop-2');
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(cOf("1-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[0])}}, 1)
          .fromTo(cOf("1-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[1])}}, 1.2)
          .fromTo(cOf("1-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[2])}}, 1.4)
          .fromTo(cOf("1-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[3])}}, 1.6)
          .fromTo(cOf("1-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[4])}}, 1.8)
          .fromTo(cOf("pop-2-text-7"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2)
          .fromTo(cOf("1-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[5])}}, 2.2)

          .staggerFromTo(cOf("pop-2-text"), 0.6, {opacity:0, y:-10}, {opacity:1, y:0, ease: Power2.easeOut}, 0.2, 1.2);
        }

        function closeOnePopTwo() {
          hideOverlay('1-pop-2')
          closePop('1-nitto-atp')
          resetNumbers("1-no");
        }

        function openOnePopFour() {
          showOverlay('1-pop-4');
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(cOf("1-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[6])}}, 1)
          .staggerFromTo(cOf("4-box"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.1)

          .fromTo(cOf("1-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[7])}}, 1.5)
          .fromTo(cOf("1-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[8])}}, 1.7);
        }

        function closeOnePopFour() {
          hideOverlay('1-pop-4')
          resetNumbers("1-no");
        }

        function openOnePopFive() {
          showOverlay('1-pop-5');
          resetNumbers('1-no');
        }

        function closeOnePopFive(id) {
          hideOverlay('1-pop-5')
          closePop('1-fan-travel')
          resetNumbers("1-no");
        }

        function popFiveAnimation(klass, id) {
          popups = cOf(klass);
          ele = idOf(id);
          resetNumbers("1-no");
          pg1Anim.stop();

          for(var i=0; i<popups.length; i++) {
            popups[i].className = klass + " hidden noclick";
          }
          childs = cOf('1-fan-travel-phone')
          childs.className = '1-fan-travel-phone hidden click'
          ele.className = klass + " visible"

          pg1Anim = new TimelineMax();

          if(id == '1-fan-travel-1') {
            pg1Anim.staggerFromTo(cOf("5-title"), 0.6, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1)
            .staggerFromTo(cOf("5-heading"), 0.6, {opacity:0, y:-20}, {opacity:1, y:0, ease: Power2.easeOut}, 1.6, 1.2)
            .staggerFromTo(cOf("5-arrow"), 0.5, {opacity:0, x:-20}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1.5) 
            .staggerFromTo(cOf("5-line"), 1.2, {scaleX: 0, transformOrigin: "left center"}, {scaleX: 0.5, ease: Power2.easeOut}, 0.6, 1.7)
            .staggerFromTo(cOf("5-circle"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.9)
            .staggerFromTo(cOf("5-arrow-2"), 0.5, {opacity:0, x:-20}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 2.8)
            .staggerFromTo(cOf("5-outline"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.9)
            .fromTo(cOf("1-no")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[9])}}, 2.8)
            .fromTo(cOf("1-no")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[10])}}, 2.9)
            .fromTo(cOf("1-no")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[11])}}, 3)
            .fromTo(cOf("1-no")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[12])}}, 3.4)
            .fromTo(cOf("1-no")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[13])}}, 3.5)
            .fromTo(cOf("1-no")[14], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[14])}}, 3.6)
            .fromTo(cOf("1-no")[15], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[15])}}, 4)
            .fromTo(cOf("1-no")[16], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[16])}}, 4.3)
            .fromTo(cOf("1-no")[17], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[17])}}, 4.6)

            pg1Anim.fromTo(cOf("bluebox"), 0.5, {opacity:0, x:25}, {opacity:1, x:0, ease: Power2.easeOut}, 4.8)
            .fromTo(cOf("5-title-2"), 0.4, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 4.9)
            .staggerFromTo(cOf("5-subtext"), 0.4, {opacity:0, x:20}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 5)

            .fromTo(cOf("1-no")[18], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[18])}}, 5.1)
            .fromTo(cOf("1-no")[19], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[19])}}, 5.1)
            .fromTo(cOf("1-no")[20], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[20])}}, 5.1)

            .staggerFromTo(cOf("5-heading-text"), 0.4, {opacity:0, y:20}, {opacity:1, y:0, ease: Power2.easeOut}, 0.6, 5.3)
            .fromTo(cOf("5-piechart"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 5.6)
            .fromTo(cOf("5-piechart-2"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 6.2)
            .fromTo(cOf("5-quote"), 0.8, {opacity:0, x:25}, {opacity:1, x:0, ease: Power2.easeOut}, 6.4)
          } else if(id == '1-fan-travel-2') {

          } else if(id == '1-fan-travel-3') {
            pg1Anim.fromTo(cOf("1-no")[21], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[21])}}, 1)
            .fromTo(cOf("1-no")[22], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[22])}}, 1.2)
            .fromTo(cOf("1-no")[23], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[23])}}, 1.4)
            .fromTo(cOf("1-no")[24], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[24])}}, 1.6)
          } else if(id == '1-fan-travel-4') {
            pg1Anim.fromTo(cOf("1-no")[25], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[25])}}, 1)
            .fromTo(cOf("1-no")[26], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[26])}}, 1.2)
            .fromTo(cOf("1-no")[27], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[27])}}, 1.4)
            .fromTo(cOf("1-no")[28], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[28])}}, 1.6)
          } else if(id == '1-fan-travel-5') {
            pg1Anim.fromTo(cOf("1-no")[29], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[29])}}, 1)
            .fromTo(cOf("1-no")[30], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[30])}}, 1.2)
            .fromTo(cOf("1-no")[31], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[31])}}, 1.4)
            .fromTo(cOf("1-no")[32], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("1-no")[32])}}, 1.6);
          }


        }

        function onPageLeave() {
          pg1Anim.stop();
          resetNumbers("1-no");
        }

      `,
      "searchText": "2025  NITTO ATP FINALS  CARBON TRACKER 2.0  SPORT IMPACT SUMMIT  FAN TRAVEL  Sustainability updates Click the panels to read more about our 2025 updates  CARBON FOOTPRINT"
    }]],
    "script": `
          function idOf(id) {
      return document.getElementById(id)
    }

    function cOf(klass) {
      return document.getElementsByClassName(klass)
    }
    
    function removeContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) { 
        return e.className = 'addContentLink'
      })
    }

    function addContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'contentLink addContentLink'
      })
    }

    function showOverlay(idx) {
      idOf(idx).className = 'contentOverlay visible'
    }

    function hideOverlay(idx) {
      idOf(idx).className = 'contentOverlay hidden noclick'
    }

    function animateNumber(element){
      if(element.getAttribute("data-number")){
        var args = JSON.parse(element.getAttribute("data-number"));
        var from = 0;
        var to = 100;
        var append = "";
        var preppend = "";
        var decimals = 0;
        var duration = 1;
        var ease = "Linear.easeNone";
        var comma = false;
        var separator = ",";
        var decChar = ".";
        for(obj in args){
          if(obj == "from") from = args[obj];
          if(obj == "to") to = args[obj];
          if(obj == "append") append = args[obj];
          if(obj == "preppend") preppend = args[obj];
          if(obj == "decimals") decimals = args[obj];
          if(obj == "duration") duration = args[obj];
          if(obj == "ease") ease = args[obj];
          if(obj == "comma") comma = args[obj];
          if(obj == "separator") separator = args[obj];
          if(obj == "decChar") decChar = args[obj];
        }
        var obj = {number: from}
        TweenMax.to(obj, duration, {number: to, onUpdate: function(){
          if(comma){
            var str = obj.number.toFixed(decimals).toString();
            var predec = str.split(/^d*/)[0];
            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
            var comp = newstr.replace(/^,/, '')
            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
            // if(dp[0]) dp = dp[0].replace(".", decChar);
            var dp = "";
            element.innerHTML = preppend+comp+dp+append;
          }else{
            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
          }
        }, ease: eval(ease)});
      }else{
        return;
      }
    }

    function resetNumbers(ele){
      var numbers = cOf(ele)
      for(var i=0; i<numbers.length; i++) {
        numbers[i].innerText= ""
      }
    }

    function mailChimpSubmit(){
      $('#mc-embedded-subscribe-form').submit(function (e) {
        var that = $(this);
        var mailchimpSubmit = $(this).find('input[type=submit]');
        var errorResponse = $('#mce-error-response');
        var successResponse = $('#mce-success-response');

        e.preventDefault();

        $.ajax({
          method: 'GET',
          url: that.attr('action'),
          data: that.serialize(),
          dataType: 'jsonp',
          success: function(data) {
          // If there was an error then show the error message.
            if (data.result === 'error') {
              // If the error has an error code at front then alter the message to not include the error code and hyphen.
              if(data.msg.indexOf('0') === 0) {
                data.msg = data.msg.slice(3);
              }
              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);
            }
            // If success then show message
            else {
              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);
            }
          }
        });
      });
    }
  `,
  "mobilePages": null,
  "mobileTemplate": null,
}


// WEBPACK FOOTER //
// ./src/document.js